// @ts-nocheck
import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import useAttributeDocumentPreview from '../../../../hooks/useAttributeDocumentPreview';
import DocumentPreviewModal from '../../../../features/document/components/DocumentPreviewModal';

/**
 * Compact document reference used inside draft original/current-value
 * comparisons — just the underlined name(s), no icon or separate action
 * button. Clicking previews the document, falling back to the modal's own
 * download action when the file type can't be previewed inline.
 */
const DocumentAttributeLink = ({ documentDetails, entityId, entityType }) => {
  const documents = Array.isArray(documentDetails)
    ? documentDetails
    : [documentDetails];
  const { previewDocument, previewModalProps } = useAttributeDocumentPreview({
    entityId,
    entityType,
  });

  const handlePreviewDocument = useCallback(
    (event) => {
      event?.stopPropagation();
      previewDocument(event?.currentTarget?.dataset?.documentId);
    },
    [previewDocument]
  );

  return (
    <>
      {documents.map((document, index) => {
        if (!document?.document_id) return null;
        const documentName = document?.document_name || '';
        const fileType = document?.file_type || document?.document_type || '';
        const fileName = fileType
          ? `${documentName}.${fileType}`
          : documentName;

        return (
          <React.Fragment key={document.document_id}>
            {index > 0 && ', '}
            <Typography
              component="span"
              variant="inherit"
              data-document-id={document.document_id}
              onClick={handlePreviewDocument}
              title={fileName}
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
                color: 'inherit',
              }}
            >
              {fileName}
            </Typography>
          </React.Fragment>
        );
      })}
      <DocumentPreviewModal {...previewModalProps} />
    </>
  );
};

DocumentAttributeLink.propTypes = {
  documentDetails: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        document_name: PropTypes.string,
        document_type: PropTypes.string,
        file_type: PropTypes.string,
        document_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ),
    PropTypes.shape({
      document_name: PropTypes.string,
      document_type: PropTypes.string,
      file_type: PropTypes.string,
      document_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ]).isRequired,
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  entityType: PropTypes.string,
};

export default DocumentAttributeLink;
